import { createFileRoute } from '@tanstack/react-router'

import { FaceRecognitionSettings } from '@/components/settings/face-recognition-settings'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/face-recognition',
)({
    component: FaceRecognitionSettings,
})
